// Centrale SEO / bedrijfsgegevens en schema (JSON-LD) builders voor Nexon Installatie & Service

export const SITE = {
  name: 'Nexon Installatie & Service',
  legalName: 'Nexon Installatie & Service',
  domain: 'https://nexonservice.nl',
  phoneDisplay: '0651929275',
  phoneE164: '+31651929275',
  email: 'info@NexonService.nl',
  areaServed: 'Nederland',
  yearsExperience: '5+',
  // Logo (vierkant NEXON-logo)
  logo: 'https://nexonservice.nl/nexon-logo-square.png',
  // Standaard social share afbeelding (NEXON plantenwand)
  ogImage: 'https://nexonservice.nl/nexon-wall.webp',
  sameAs: ['https://www.instagram.com/nexonservice_/'],
};

export const absoluteUrl = (path = '') => `${SITE.domain}${path.startsWith('/') ? path : `/${path}`}`.replace(/\/$/, '') || SITE.domain;

// LocalBusiness / MovingCompany schema (servicegebied: heel Nederland, geen fysiek adres)
export const organizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': ['MovingCompany', 'LocalBusiness'],
  '@id': `${SITE.domain}/#organization`,
  name: SITE.name,
  legalName: SITE.legalName,
  url: SITE.domain,
  logo: SITE.logo,
  image: SITE.ogImage,
  telephone: SITE.phoneE164,
  email: SITE.email,
  priceRange: '€€',
  description:
    'Nexon Installatie & Service is specialist in het verhuizen, transporteren, demonteren, monteren en installeren van fitnessapparatuur in heel Nederland. Van Technogym tot loopbanden en krachtstations.',
  areaServed: { '@type': 'Country', name: 'Nederland' },
  address: { '@type': 'PostalAddress', addressCountry: 'NL', addressRegion: 'Nederland' },
  sameAs: SITE.sameAs,
  knowsAbout: [
    'Fitnessapparatuur verhuizen',
    'Technogym verhuizen',
    'Loopband verhuizen',
    'Crosstrainer verhuizen',
    'Krachtstation verhuizen',
    'Fitness transport',
    'Fitnessapparatuur demonteren en monteren',
  ],
});

export const websiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE.domain}/#website`,
  url: SITE.domain,
  name: SITE.name,
  inLanguage: 'nl-NL',
  publisher: { '@id': `${SITE.domain}/#organization` },
});

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: absoluteUrl(it.path),
  })),
});

export const faqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});

export const serviceSchema = ({ name, description, path }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: name,
  name,
  description,
  url: absoluteUrl(path),
  provider: { '@id': `${SITE.domain}/#organization` },
  areaServed: { '@type': 'Country', name: 'Nederland' },
});

export const articleSchema = ({ title, description, path, datePublished, image }) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: title,
  description,
  image: image || SITE.ogImage,
  inLanguage: 'nl-NL',
  datePublished,
  dateModified: datePublished,
  mainEntityOfPage: { '@type': 'WebPage', '@id': absoluteUrl(path) },
  author: { '@type': 'Organization', name: SITE.name, url: SITE.domain },
  publisher: { '@id': `${SITE.domain}/#organization` },
});
